import { render } from "./FabColumn.vue?vue&type=template&id=5b267b6c&scoped=true"
import script from "./FabColumn.vue?vue&type=script&lang=js"
export * from "./FabColumn.vue?vue&type=script&lang=js"

import "./FabColumn.vue?vue&type=style&index=0&id=5b267b6c&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b267b6c"]])

export default __exports__